// extracted by mini-css-extract-plugin
module.exports = {"container":"Select_container__tfVtX","label":"Select_label__TjpcD","error":"Select_error__xI8ma","input":"Select_input__1Yzza"};